import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { auth } from '../constants/firebase.js';

class Login extends PureComponent {
  static propTypes = {};

  login1 = async () => {
    var email = 'test@test.com';
    var password = 'test123';

    await auth
      .signInWithEmailAndPassword(email, password)
      .catch(function(error) {
        console.log(error.code);
        console.log(error.message);
      });
    this.props.history.push('/home');
  };

  login1 = async () => {
    var email = 'test2@test2.com';
    var password = 'test234';

    await auth
      .signInWithEmailAndPassword(email, password)
      .catch(function(error) {
        console.log(error.code);
        console.log(error.message);
      });
    this.props.history.push('/home');
  };

  render() {
    return (
      <React.StrictMode>
        <div className="w-100 grid jcc mv5">
          <button onClick={this.login1} data-test="testLogin1">
            Test Login 1
          </button>
          <button onClick={this.login1} data-test="testLogin2">
            Test Login 2
          </button>
        </div>
      </React.StrictMode>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.jsx